export const storeCuisines = [
  { id: "all", label: "全部菜系" },
  { id: "guangdong", label: "粤菜烧腊" },
  { id: "noodle", label: "面食小吃" },
  { id: "bbq", label: "烧烤夜宵" },
  { id: "dessert", label: "甜品烘焙" },
] as const;

export type StoreCuisine = "guangdong" | "noodle" | "bbq" | "dessert";

export interface StoreItem {
  id: string;
  name: string;
  cuisine: StoreCuisine;
  cuisineLabel: string;
  district: string;
  price: string;
  rating: number;
  reviewCount: number;
  signature: string;
  note: string;
  openHours: string;
  image: string;
}

export const stores: StoreItem[] = [
  {
    id: "s1",
    name: "二楼烧腊档",
    cuisine: "guangdong",
    cuisineLabel: "粤菜烧腊",
    district: "老城区·菜市场二楼",
    price: "人均 ¥45",
    rating: 4.8,
    reviewCount: 1286,
    signature: "蜜汁叉烧、烧鹅腿",
    note: "每天上午十点出炉，卖完即止；建议避开十二点高峰，排队约二十分钟。",
    openHours: "10:00 - 14:00",
    image:
      "https://readdy.ai/api/search-image?query=Chinese%20roast%20meat%20shop%20counter%20with%20hanging%20roast%20duck%20and%20char%20siu%2C%20warm%20amber%20light%2C%20busy%20market%20atmosphere%2C%20appetizing%20documentary%20food%20photography%2C%20high%20detail&width=800&height=600&seq=store-char-siu-stall-11&orientation=landscape",
  },
  {
    id: "s2",
    name: "老巷馄饨摊",
    cuisine: "noodle",
    cuisineLabel: "面食小吃",
    district: "和平里·巷口",
    price: "人均 ¥15",
    rating: 4.9,
    reviewCount: 2104,
    signature: "鲜肉小馄饨、虾籽拌面",
    note: "晚上七点出摊，猪骨汤底熬四小时；现金与扫码均可，辣椒油是自家炼的。",
    openHours: "19:00 - 01:00",
    image:
      "https://readdy.ai/api/search-image?query=Small%20night%20street%20food%20stall%20serving%20wonton%20soup%2C%20warm%20string%20lights%2C%20steam%20rising%2C%20cozy%20nostalgic%20documentary%20photography%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=store-wonton-night-12&orientation=landscape",
  },
  {
    id: "s3",
    name: "炭火三兄弟烧烤",
    cuisine: "bbq",
    cuisineLabel: "烧烤夜宵",
    district: "滨江路·夜市第 8 摊",
    price: "人均 ¥60",
    rating: 4.6,
    reviewCount: 934,
    signature: "羊肉串、烤茄子、烤生蚝",
    note: "纯炭火烤制，羊肉串现穿现烤；每晚十点后有小份拼盘，适合两三人小聚。",
    openHours: "18:00 - 02:00",
    image:
      "https://readdy.ai/api/search-image?query=Charcoal%20barbecue%20skewers%20grilling%20over%20open%20fire%20at%20a%20night%20market%2C%20smoke%20and%20glow%2C%20warm%20orange%20tones%2C%20lively%20street%20food%20documentary%20photography&width=800&height=600&seq=store-charcoal-bbq-13&orientation=landscape",
  },
  {
    id: "s4",
    name: "奶油小方烘焙室",
    cuisine: "dessert",
    cuisineLabel: "甜品烘焙",
    district: "文化路·创意园 A 栋",
    price: "人均 ¥38",
    rating: 4.7,
    reviewCount: 761,
    signature: "巴斯克芝士、盐可颂",
    note: "每日下午两点上新，热门款常在一小时内售罄；堂食有六张小桌，可提前电话预留。",
    openHours: "11:00 - 19:00",
    image:
      "https://readdy.ai/api/search-image?query=Rustic%20basque%20burnt%20cheesecake%20and%20salt%20croissants%20on%20a%20marble%20counter%20in%20a%20cozy%20bakery%2C%20soft%20warm%20daylight%2C%20minimal%20beige%20background%2C%20editorial%20food%20photography&width=800&height=600&seq=store-bakery-basque-14&orientation=landscape",
  },
  {
    id: "s5",
    name: "手工竹升面馆",
    cuisine: "noodle",
    cuisineLabel: "面食小吃",
    district: "西关·骑楼街",
    price: "人均 ¥28",
    rating: 4.5,
    reviewCount: 1102,
    signature: "鲜虾云吞竹升面、牛腩捞面",
    note: "面条每日现压，碱水味不重；汤头清亮，适合清淡口味。午市十一点半开始排队。",
    openHours: "11:00 - 20:30",
    image:
      "https://readdy.ai/api/search-image?query=Bowl%20of%20cantonese%20bamboo%20pressed%20noodles%20with%20shrimp%20wontons%20and%20clear%20broth%2C%20warm%20daylight%2C%20traditional%20teahouse%20setting%2C%20appetizing%20food%20photography&width=800&height=600&seq=store-bamboo-noodle-15&orientation=landscape",
  },
  {
    id: "s6",
    name: "深夜炭烤生蚝档",
    cuisine: "bbq",
    cuisineLabel: "烧烤夜宵",
    district: "江畔·码头夜市",
    price: "人均 ¥55",
    rating: 4.4,
    reviewCount: 688,
    signature: "蒜蓉生蚝、烤扇贝",
    note: "生蚝当日到货，蒜蓉现调；凌晨一点前供应最足，之后视当日库存而定。",
    openHours: "20:00 - 03:00",
    image:
      "https://readdy.ai/api/search-image?query=Grilled%20oysters%20with%20garlic%20sauce%20on%20a%20charcoal%20grill%20at%20a%20night%20seafood%20stall%2C%20warm%20firelight%2C%20smoke%2C%20appetizing%20street%20food%20documentary%20photography&width=800&height=600&seq=store-grilled-oyster-16&orientation=landscape",
  },
];